import { Component } from '@angular/core';
import { RoutePath } from '@core/routing/routing.types';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  private readonly slash: string = '/';
  footerNavContent = [
    {
      name: 'Impressum',
      id: 'Imprint',
      uri: this.slash + RoutePath.LANDING + this.slash + RoutePath.IMPRINT,
    },
    {
      name: 'Datenschutz',
      id: 'Data privacy',
      uri: this.slash + RoutePath.PRIVACY_REM,
    },
  ];
}
